import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button'];
  static values = { radioId: String };

  connect() {
    console.log('ButtonWithRadio controller connected');
    this.updateRadioState();
  }

  toggle(event) {
    event.preventDefault();
    console.log('Toggle method called');

    const radio = this.findRadio();
    const dot = this.findDot();

    if (!radio || !dot) {
      console.error('Radio or dot not found');
      return;
    }

    // Marcar este radio
    radio.checked = true;
    this.updateDotVisual(dot, true);

    // Desmarcar outros radios
    this.deselectOtherRadios();
  }

  findRadio() {
    const radio = document.getElementById(this.radioIdValue);
    console.log('Looking for radio with ID:', this.radioIdValue, 'Found:', radio);
    return radio;
  }

  findDot() {
    const radio = this.findRadio();
    if (!radio) return null;

    const dot = radio.parentElement.querySelector('.tw-w-2.tw-h-2');
    console.log('Looking for dot, Found:', dot);
    return dot;
  }

  updateRadioState() {
    const radio = this.findRadio();
    const dot = this.findDot();

    if (radio && dot) {
      this.updateDotVisual(dot, radio.checked);
    }
  }

  updateDotVisual(dot, isChecked) {
    if (isChecked) {
      dot.classList.remove('tw-opacity-0');
      dot.classList.add('tw-opacity-100');
    } else {
      dot.classList.remove('tw-opacity-100');
      dot.classList.add('tw-opacity-0');
    }
  }

  deselectOtherRadios() {
    const allRadios = document.querySelectorAll('input[type="radio"]');

    allRadios.forEach((otherRadio) => {
      if (otherRadio.id !== this.radioIdValue) {
        otherRadio.checked = false;

        const otherDot = otherRadio.parentElement.querySelector('.tw-w-2.tw-h-2');
        if (otherDot) {
          this.updateDotVisual(otherDot, false);
        }
      }
    });
  }
}
